export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["SET_1"] = "SET_1";
    TransactionStatus["SET_2"] = "SET_2";
    TransactionStatus["SET_3"] = "SET_3";
    TransactionStatus["SET_4"] = "SET_4";
    TransactionStatus["SET_5"] = "SET_5";
    TransactionStatus["SET_6"] = "SET_6";
    TransactionStatus["SET_7"] = "SET_7";
    TransactionStatus["SET_8"] = "SET_8";
    TransactionStatus["SET_9"] = "SET_9";
    TransactionStatus["SET_10"] = "SET_10";
    TransactionStatus["SET_11"] = "SET_11";
    TransactionStatus["SET_12"] = "SET_12";
    TransactionStatus["SET_13"] = "SET_13";
    TransactionStatus["SET_14"] = "SET_14";
    TransactionStatus["SET_15"] = "SET_15";
    TransactionStatus["SET_16"] = "SET_16";
    TransactionStatus["SET_17"] = "SET_17";
    TransactionStatus["SET_18"] = "SET_18";
    TransactionStatus["SET_19"] = "SET_19";
    TransactionStatus["SET_20"] = "SET_20";
    TransactionStatus["SET_21"] = "SET_21";
    TransactionStatus["SET_22"] = "SET_22";
    TransactionStatus["SET_23"] = "SET_23";
    TransactionStatus["SET_24"] = "SET_24";
    TransactionStatus["SET_25"] = "SET_25";
})(TransactionStatus || (TransactionStatus = {}));
//# sourceMappingURL=transactionStatus.js.map